import clsx from 'clsx';
import styles from './PageSubheader.module.css';

export function PageSubheader({ title, left, right, className = '' }) {
  return (
    <section className={clsx(styles.subheader, className)}>
      <div className={clsx(styles.row)}>
        {left ? left : <h1 className={clsx(styles.title)}>{title}</h1>}
        <div className={clsx(styles.right)}>{right}</div>
      </div>
    </section>
  );
}
